import { useCallback } from 'react';

import { AxiosResponse } from 'axios';

import { useSuspenseQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';

export type TypeSpecialMedicalResponseData = {
  /** 특수건강검진 ID */
  specialMedicalExaminationId: number;
  /** 제출 상태 */
  status: {
    code: string;
    text: string;
  };
  /** 작업자 근무 CC */
  cluster: string | null;
  /** 특수건강검진 검진일자 */
  examinationDate: string | null;
  /** 반려 사유 */
  rejectionReason: string | null;
  /** 이미지 URL */
  presignedUrl: string | null;
  /** 이미지 파일명 */
  fileName: string | null;
};

export type TypeSpecialMedicalResponse = {
  code: string;
  message: string;
  data: TypeSpecialMedicalResponseData;
};

/** @description 작업자의 특수건강검진 관련 정보 조회 */
export const useGetSpecialMedical = () => {
  const handleResponse = useCallback((response: AxiosResponse<TypeSpecialMedicalResponse>) => {
    return response.data.data;
  }, []);

  const { data, refetch } = useSuspenseQuery({
    queryKey: ['special-medical-detail'],
    queryFn: async () => {
      const endpoint = '/labor-accounts/examinations/special-medicals';
      return await axiosInstance.get(endpoint);
    },
    gcTime: 0,
    retry: 1,
    select: (response) => handleResponse(response),
  });

  return { data, refetch };
};
